enum EdgeType {
	GROUND = 'Ground',
	BLOCK_ATTACHED = 'Block Attached',
	HOUSE = 'House',
	HOUSE_ATTACHED = 'House Attached',
	RAILING = 'Railing',
	NO_RAILING = 'No Railing',
	DECKING = 'Decking',
	LANDING_ATTACHED = 'Landing Attached',
	STAIR_ATTACHED = 'Stair Attached',
	HOUSE_FREESTANDING = 'House Freestanding',
	BUMPOUT = 'Bump out',
	DECKBOX = 'Deckbox',
	LANDING = 'Landing',
	STAIR = 'Stair',
}

export default EdgeType;
